import { useState } from 'react';

export default function SettingsPage() {
  const [companyForm, setCompanyForm] = useState({
    name: '',
    cnpj: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    phone: '',
    email: '',
  });

  const [apiKeys, setApiKeys] = useState({
    webhookUrl: '',
    webhookSecret: '',
    apiKey: '',
  });

  const [notifications, setNotifications] = useState({
    emailOnNewOrder: true,
    emailOnShipped: true,
    emailOnDelivered: true,
    emailOnError: true,
    smsOnError: false,
  });

  return (
    <div className="space-y-6 max-w-3xl">
        <div className="bg-white rounded-xl p-6 shadow-sm border border-dark-100">
          <h3 className="text-sm font-semibold text-dark-500 uppercase mb-4">Dados da Empresa</h3>
          <form className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-dark-700 mb-1">Razao Social</label>
                <input
                  type="text"
                  value={companyForm.name}
                  onChange={(e) => setCompanyForm({ ...companyForm, name: e.target.value })}
                  className="w-full px-3 py-2 border border-dark-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-dark-700 mb-1">CNPJ</label>
                <input
                  type="text"
                  value={companyForm.cnpj}
                  onChange={(e) => setCompanyForm({ ...companyForm, cnpj: e.target.value })}
                  className="w-full px-3 py-2 border border-dark-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-dark-700 mb-1">Endereco</label>
              <input
                type="text"
                value={companyForm.address}
                onChange={(e) => setCompanyForm({ ...companyForm, address: e.target.value })}
                className="w-full px-3 py-2 border border-dark-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
            </div>
            <div className="grid grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-dark-700 mb-1">Cidade</label>
                <input
                  type="text"
                  value={companyForm.city}
                  onChange={(e) => setCompanyForm({ ...companyForm, city: e.target.value })}
                  className="w-full px-3 py-2 border border-dark-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-dark-700 mb-1">UF</label>
                <input
                  type="text"
                  value={companyForm.state}
                  onChange={(e) => setCompanyForm({ ...companyForm, state: e.target.value })}
                  className="w-full px-3 py-2 border border-dark-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                  maxLength={2}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-dark-700 mb-1">CEP</label>
                <input
                  type="text"
                  value={companyForm.zipCode}
                  onChange={(e) => setCompanyForm({ ...companyForm, zipCode: e.target.value })}
                  className="w-full px-3 py-2 border border-dark-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-dark-700 mb-1">Telefone</label>
                <input
                  type="text"
                  value={companyForm.phone}
                  onChange={(e) => setCompanyForm({ ...companyForm, phone: e.target.value })}
                  className="w-full px-3 py-2 border border-dark-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-dark-700 mb-1">Email</label>
                <input
                  type="email"
                  value={companyForm.email}
                  onChange={(e) => setCompanyForm({ ...companyForm, email: e.target.value })}
                  className="w-full px-3 py-2 border border-dark-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                />
              </div>
            </div>
            <div className="pt-2">
              <button
                type="button"
                className="px-4 py-2 bg-primary-600 text-white rounded-lg text-sm font-medium hover:bg-primary-700 transition-colors"
              >
                Salvar Dados
              </button>
            </div>
          </form>
        </div>

        <div className="bg-white rounded-xl p-6 shadow-sm border border-dark-100">
          <h3 className="text-sm font-semibold text-dark-500 uppercase mb-4">Chaves de API</h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-dark-700 mb-1">Webhook URL</label>
              <input
                type="url"
                value={apiKeys.webhookUrl}
                onChange={(e) => setApiKeys({ ...apiKeys, webhookUrl: e.target.value })}
                className="w-full px-3 py-2 border border-dark-200 rounded-lg text-sm font-mono focus:outline-none focus:ring-2 focus:ring-primary-500"
                placeholder="https://..."
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-dark-700 mb-1">Webhook Secret</label>
              <input
                type="password"
                value={apiKeys.webhookSecret}
                onChange={(e) => setApiKeys({ ...apiKeys, webhookSecret: e.target.value })}
                className="w-full px-3 py-2 border border-dark-200 rounded-lg text-sm font-mono focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-dark-700 mb-1">API Key</label>
              <input
                type="password"
                value={apiKeys.apiKey}
                onChange={(e) => setApiKeys({ ...apiKeys, apiKey: e.target.value })}
                className="w-full px-3 py-2 border border-dark-200 rounded-lg text-sm font-mono focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
            </div>
            <div className="pt-2">
              <button
                type="button"
                className="px-4 py-2 bg-primary-600 text-white rounded-lg text-sm font-medium hover:bg-primary-700 transition-colors"
              >
                Salvar Chaves
              </button>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-6 shadow-sm border border-dark-100">
          <h3 className="text-sm font-semibold text-dark-500 uppercase mb-4">Notificacoes</h3>
          <div className="space-y-4">
            {[
              { key: 'emailOnNewOrder', label: 'Email ao receber novo pedido' },
              { key: 'emailOnShipped', label: 'Email ao despachar pedido' },
              { key: 'emailOnDelivered', label: 'Email ao confirmar entrega' },
              { key: 'emailOnError', label: 'Email ao ocorrer erro' },
              { key: 'smsOnError', label: 'SMS ao ocorrer erro critico' },
            ].map(({ key, label }) => (
              <label key={key} className="flex items-center gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={(notifications as any)[key]}
                  onChange={(e) => setNotifications({ ...notifications, [key]: e.target.checked })}
                  className="rounded border-dark-300 text-primary-600 focus:ring-primary-500"
                />
                <span className="text-sm text-dark-700">{label}</span>
              </label>
            ))}
            <div className="pt-2">
              <button
                type="button"
                className="px-4 py-2 bg-primary-600 text-white rounded-lg text-sm font-medium hover:bg-primary-700 transition-colors"
              >
                Salvar Preferencias
              </button>
            </div>
          </div>
        </div>
    </div>
  );
}
